<template>
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
    <div class="box box-danger box-solid">
      <div class="box-header with-border">
        <h3 class="box-title" id="title"><i class="fa fa-exclamation-triangle mr-5"></i>{{'no_' + type | translate}}</h3>
        <div class="box-tools pull-right">
          <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i>
          </button>
          <button type="button" class="btn btn-box-tool" data-widget="remove"><i class="fa fa-times"></i></button>
        </div>
      </div>
      <div class="box-body">
        <div v-if="loading">
          <img class="loading-gif" src="/static/img/blabla.svg"/>
        </div>
        <div class="table-responsive" v-else-if="items.length > 0">
          <table class="table table-hover">
            <thead>
            <tr>
              <th>#</th>
              <th>{{'date' | translate}}</th>
              <th>Order-ID</th>
              <th>Line-ID</th>
              <th>SKU / GTIN</th>
              <template v-if="type === 'merchant'">
                <th>Cancelled by</th>
              </template>
              <th>{{'retail_price' | translate}}</th>
              <th>{{'sales_channel' | translate}}</th>
              <th></th>
              <th></th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <template v-for="(item, index) in items">
              <monitoring-row :item="item" :index="index" :type="type" :loading="loadingRows" @open="openModal($event)" @toggleSecondRow="find(item)"></monitoring-row>
              <store-row :secondRow="item.showSecondRow" :rows="item.rows" :item="item" :index="index" :type="type" @deleteRow="$emit('deleteRow', $event)"></store-row>
            </template>
            </tbody>
          </table>
        </div>
        <div v-else>
          <h3>{{`Keine Fehler${type === 'merchant' ? ' in Bestellzuordnung' : ''}`}}</h3>
        </div>
      </div>
      <div class="box-footer"></div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['items', 'type', 'loading', 'loadingRows'],
  data () {
    return {
      disabled: []
    }
  },
  methods: {
    findBy (find, kind, channel) {
      API.get(`monitoring/anwr/${channel}/findSku/${find.sku}/${find.gtin}`)
        .then(response => {
          this.$emit('query', response.bodyText)
        })
    },
    openModal (obj) {
      this.$parent.openCancelModal(obj)
    },
    cancelOrder (id) {
      API.put(`orders/line/${id}/fullcancel`, {reason: 'no_merchant_found'})
        .then(response => {
          this.$emit('alert', ['success', 'Success', 'fa fa-check'])
        })
        .catch(error => {
          this.$emit('alert', ['danger', error.response.data.message, 'fa fa-ban'])
        })
    },
    find (item) {
      if (!item.showSecondRow) {
        API.get(`monitoring/order/line/${item.order_item_line_id}/find`)
          .then(res => {
            item.rows = res.data
            item.showSecondRow = true
          })
      } else {
        item.showSecondRow = false
      }
    }
  },
  watch: {
    model () {
      this.orders = []
    },
    items () {},
    loading () {}
  }
}
</script>
<style scoped>
  .loading-gif {
    max-width: 345px;
    margin-left: 42%;
  }
</style>



// WEBPACK FOOTER //
// src/components/tools/Tables/MonitoringTableComponent.vue